import $ from 'jquery';
import Q from 'q';
import LZString from 'lz-string';
import _ from 'underscore';
import LayoutManager from './LayoutManager';

function history(){
  var ua = navigator.userAgent;
  // We only want Android 2 and 4.0, stock browser, and not Chrome which identifies
  // itself as 'Mobile Safari' as well, nor Windows Phone (issue #1471).
  if ((ua.indexOf('Android 2.') !== -1 ||
      (ua.indexOf('Android 4.0') !== -1)) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1 &&
  // Since all documents on file:// share an origin, the History apis are
  // blocked there as well
      location.protocol !== 'file:'
  ) {
    return false;
  }

  // Return the regular check
  return (window.history && 'pushState' in window.history);
}

var Modernizr = {
  history: history(),
};

// static namespace
var StateManager = {};


/**
 * Transforme l'url full (avec http://) en url absolue
 * commençant par un slash à la racine du vhost
 */
function cleaupUrl(url) {
    // TODO: remplacer par une regex qui prend en compte tous les cas
    return url.replace(/^http[s]?:\/\/[^\/]+/, ''); // eslint-disable-line no-useless-escape
}

  // TODO: Cleaner ce code en reprenant tous les use case
function getPathFromUrl(url) {
    return url.split(/[?#]/)[0].replace(/^http[s]?:\/\/[^\/]+/, ''); // eslint-disable-line no-useless-escape
}

/**
 * Indique si l'url d'une page correspond à celle de l'url en cours.
 */
function isCurrentPage(pageUrl, currentUrl/*= null*/) {
  if (!currentUrl){
    currentUrl = getPathFromUrl(window.location.href);
  }
  if (pageUrl != undefined){
    return pageUrl === currentUrl.substr(0,pageUrl.length);
  }
  else{
    return false;
  }
}

/**
 * Patch alternatif pour mobile avec search
 */
function isCurrentPage2(pageUrl, currentUrl/*= null*/) {
  if (!currentUrl) currentUrl = getPathFromUrl(window.location.href);
  if (pageUrl != undefined) {
    pageUrl = getPathFromUrl(pageUrl);
    return pageUrl === currentUrl.substr(0,pageUrl.length);
  }
  else{
    return false;
  }
}




/* --------------------------------------------------

    EVENT TYPES

-------------------------------------------------- */

/**
 * @event
 * Déclenché lorsqu'une nouvelle page est ajoutée au DOM et prête à être initialisée.
 *
 * @param  {DOM Element}  node  L'élément prêt à être initialisé.
 */
StateManager.CONTENT_READY = 'scuba:contentReady';

/**
 * @event
 * Déclenché lorsqu'une action utilisateur demande la modification de l'affichage.
 *
 * @param  {String}  fromPageUrl  Url de la page qui a initialisé le pushState.
 */
StateManager.PUSH_STATE = 'scuba:pushState';

/**
 * @event
 *
 * @param  {String}  fromPageUrl  Url de la page qui a initialisé le pushState.
 */
StateManager.POP_STATE = 'scuba:popState';

/**
 * @event
 * Déclenché lorsque l'état de la page a changé.
 *
 * @parap  {Array}  state  Liste des pages affichées.
 */
StateManager.STATE_CHANGE = 'scuba:stateChange';

/**
 * @event
 * Déclenché sur chaque page (de la dernière à la première) puis sur le header pour
 * indiquer que les pages suivantes ont changé.
 *
 * @param  {Array}  state  Liste des pages affichées après l'élément.
 */
StateManager.NEXT_PAGES_CHANGED = 'scuba:nextPagesChanged';

/**
 * ...
 */
StateManager.REFRESH_SOURCE = 'scuba:refreshSource';

/**
 * ...
 */
StateManager.DISPOSE = 'scuba:dispose';





/* --------------------------------------------------

    PRIVATE PROPERTIES

-------------------------------------------------- */

/* -------------------------
    DOM ELEMENTS
------------------------- */

var $window = $(window);
var $document = $(document);

// autres éléments récupérés lorsque le DOM est prêt
var $body, $head, $main;


/* -------------------------
    VARIABLES
------------------------- */

// utilisé pour empêcher des chargements simultanés
var isChangingState = false;


/* -------------------------
    CONFIG
------------------------- */

var options = { debug: false };





/* --------------------------------------------------

    PUBLIC METHODS

-------------------------------------------------- */

/**
 * Initialise la gestion des états de l'affichage.
 *
 * @param  {Object}  params  Configuration (optionnel).
 *
 * @return  {Promise}  Promesse résolue lorsque la page est initialisée.
 */
StateManager.init = init;
function init(params/*= null*/) {
    options.debug && console.info('init');

    // récupération des options
    $.extend(true, options, params);

    // initialise le header
    initNodeContent($head);

    // récupération du titre de la page actuelle
    var title = $('head title').text();
    $('.js-scuba__main .js-scuba__page').attr('data-title', title);

    // récupération de l'état actuel
    var currentState = getCurrentState();
    // récupération de l'url actuelle
    var currentUrl = cleaupUrl(location.href);

    // sur mobile, ne charge pas les pages à droite de l'url actuelle
    var layout = LayoutManager.getAvailableLayout();
    var isMobile = layout && layout.name === 'MobileLayout';
    if (isMobile && currentState.length > 1) {
        var currentPage = _.find(currentState, function(page) {
            return isCurrentPage2(page.url, currentUrl);
        }, this);
        currentState = _.first(currentState, _.indexOf(currentState, currentPage) + 1);
    }

    // affichage de l'état
    if (Modernizr.history) {
        // récupère l'état dans l'historique
        var state = history.state ? history.state : [];

        if (state.length > 0) {
            var found = false/*, match*/;
            currentState = _.filter(currentState, function(page) {
                if (found) return true;
                if (page.url === currentUrl.substr(-page.url.length)) {
                    return found = true;
                }
                return false;
            });
        }

        // ... et y ajoute le pages actuelles
        state = state.concat(currentState);
        // met à jour l'affichage
        return applyState(state);
    } else {
        // récupère et nettoie le hash
        var hash = (window.location.hash || '').replace(/^(#)/, '');
        if (hash) {
            // récupère l'état dans le nouveau hash
            var infos = hashToState(hash);
            // charge la page
            return loadAndApplyState(infos.url, infos.pagesBefore, infos.pagesBefore.length > 0);
        } else {
            // met à jour l'affichage
            return applyState(currentState);
        }
    }
}


/* -------------------------
    PUSH STATE
------------------------- */

/**
 * Demande le changement des éléments affichés.
 *
 * @param  {String}  url         Url à afficher.
 * @param  {String}  target      Cible d'affichage des nouveaux éléments : "root", "after" ou "self" ("root" par défaut).
 * @param  {String}  fromPageUrl  Url de la page relative à la "target" (null par défaut).
 *
 * @return  {Promise}
 */
StateManager.pushState = pushState;
function pushState(url, target/*= root*/, fromPageUrl/*= null*/) {
    if (_.indexOf(['self','after'], target) < 0) target = 'root';
    if (fromPageUrl === undefined) fromPageUrl = null;
//console.info('pushState(', url, target, fromPageUrl, ')');
    options.debug && console.info('pushState(', url, target, fromPageUrl, ')');

    // empêche qu'il y ai des chargements simultanés
    if (isChangingState) {
        return Q.reject("Impossible de charger du contenu tant que le précédent chargement n'est pas terminé.");
    }

    var state = [];
    if (target !== 'root') {
        var pages = getCurrentState();
        $.each(pages, function(i, page) {
            if (target === 'self' && fromPageUrl === page.url) return false; // coupe la boucle
            state.push(page);
            if (target === 'after' && fromPageUrl === page.url) return false; // coupe la boucle
        });
    }

    // déclenche l'évènement
    $window.trigger(StateManager.PUSH_STATE, [fromPageUrl]);

    if (Modernizr.history) {
        // ajoute une entrée dans l'historique
        window.history.pushState(state, null, url);
        // charge la page
        return loadAndApplyState(url, state, (target === 'after' || target === 'self')).fail(function(reason){
            console.error(reason && reason.stack ? reason.stack : reason);
        });
    } else {
        var hash = stateToHash(state, url);
        window.location.hash = hash;
        return Q.resolve();
    }
}



var hashSeparator = '|';

function stateToHash(state, url) {
    var hash = [];

    // ajout des pages précédentes
    var i = 0;
    var n = state.length;
    for (; i < n; i++) {
        hash.push(state[i].url);
    }

    // ajout de l'url en cours
    hash.push(url);

    // conversion en chaine
    hash = hash.join(hashSeparator);

    // compresse le hash
    hash = LZString.compressToBase64(hash);

    return hash;
}

function hashToState(hash) {
    var infos = {
        pagesBefore: [],
        url: false,
    };

    // décompresse le hash
    hash = LZString.decompressFromBase64(hash);
    hash = hash || '';

    // découpe la chaine
    hash = hash.split(hashSeparator);

    // récupère la dernière url
    infos.url = hash.pop();

    // ajout des pages précédentes
    var i = 0;
    var n = hash.length;
    for (; i < n; i++) {
        infos.pagesBefore.push({
            url: hash[i],
        });
    }

    return infos;
}


/* -------------------------
    POP STATE
------------------------- */

/**
 * Retire la dernière entrée de l'état.
 */
StateManager.popState = popState;
function popState() {
    options.debug && console.info('popState()');

    // empêche qu'il y ai des chargements simultanés
    if (isChangingState) return Q.reject("Impossible de charger du contenu tant que le précédent chargement n'est pas terminé.");

    // récupère l'état actuel
    var state = getCurrentState();

    // retire le dernier élément
    var removedPage = state.pop();

    if (state.length < 1) return Q.reject("Impossible remonter plus haut.");

    // retire le dernier élément
    var lastPage = state[0];

    // ajoute une entrée dans l'historique
    window.history.pushState(removedPage, null, lastPage.url);

    // déclenche l'évènement
    $window.trigger(StateManager.POP_STATE, [state.slice(0)]);

    // charge la page
    return applyState(state);
}





/* --------------------------------------------------

    PRIVATE METHODS

-------------------------------------------------- */

/* -------------------------
    EVENT :: DOCUMENT READY
------------------------- */

/**
 * Écoute l'initialisation du DOM pour récupèrer les éléments structurants.
 */
$document.ready(document_readyHander);
function document_readyHander() {
    $body = $('body');
    $head = $('.js-scuba__head').first();
    $main = $('.js-scuba__main').first();
}


/* -------------------------
    EVENT :: POP STATE
------------------------- */

/**
 * Écoute le changement du state par le navigateur.
 */
function window_popStateHander(event) {
    options.debug && console.info('window_popStateHander()');

    preventHistoryScroll();

    // récupère l'état de l'historique
    var state = event.originalEvent.state || [];

    // charge la page
    loadAndApplyState(cleaupUrl(location.href), state, state.length > 0).
        fail(function(reason) {
            console.error(reason && reason.stack ? reason.stack : reason);
        });
}

function preventHistoryScroll() {
    // enregistre la position avant
    var scrollLeft = $body.scrollLeft();

    var handler = function() {
        $body.scrollLeft(scrollLeft);
    }

    // écoute les scroll et repositionne
    $window.on('scroll', handler);
    setTimeout(function() {
        handler();
        $window.off('scroll', handler);
    }, 1);
}

/* -------------------------
    EVENT :: HASH CHANGE
------------------------- */

/**
 * Écoute le changement du hash par le navigateur.
 */
function window_hashChangeHander(/*event*/) {
    options.debug && console.info('window_hashChangeHander()');

    // récupère et nettoie le hash
    var hash = (window.location.hash || '').replace(/^(#)/, '');

    // récupère l'état dans le nouveau hash
    var infos = hashToState(hash);

    // charge la page
    loadAndApplyState(infos.url, infos.pagesBefore, infos.pagesBefore.length > 0);
}

if (Modernizr.history) {
    $window.on('popstate', window_popStateHander);
} else {
    $window.on('hashchange', window_hashChangeHander);
}


/* -------------------------
    LOAD AND APPLY STATE
------------------------- */

/**
 * Ajoute les page de l'url à celle du "state" en paramètre.
 *
 * @param  {String}  url           Url à charger.
 * @param  {Array}   pagesBefore   Liste des page à conserver.
 * @param  {Boolean} removeBranch  Demande à ne pas charger les pages avant l'url cible.
 *
 * @return  {Promise} Promesse retournant l'état final.
 */
function loadAndApplyState(url, pagesBefore, removeBranch) {
    removeBranch = !!removeBranch;

    options.debug && console.info('loadAndApplyState(', url, pagesBefore, removeBranch, ')');

    isChangingState = true;

    return loadPage(url, removeBranch ? true : false, removeBranch ? true : false)
        .then(function(newPages) {

            if ($(document.body).data('layout') === 'MobileLayout') {
                var i = 0, n = newPages.length, page;
                for (; i < n; i++) {
                    page = newPages[i];
                    if (url == page.url) {
                        newPages = newPages.slice(0, i+1);
                        break;
                    }
                }
            }

            // TODO: s'il y a des pagesBefore, supprimer les newPages avant celle de l'url.
            // ajoute les pages "avant" aux nouvelles pages
            pagesBefore = pagesBefore.concat(newPages);
            // affiche le nouvel état
            return applyState(pagesBefore);
        })
        .fin(function(/*state*/) {
            isChangingState = false;
        });
}


/* -------------------------
    APPLY STATE
------------------------- */

/**
 * Modifie le contenu de la page.
 *
 * @param  {String}  state  Liste des page à afficher.
 *
 * @return  {Promise}
 */
function applyState(state) {
    options.debug && console.info('applyState(', state, ')');

    isChangingState = true;

    return applyState_makeDiff(state) // effectue le diff en l'état actuel et le nouveau
        .then(applyState_loadPages) // charge les pages manquantes
        .then(applyState_updateDom) // affiche les page sur le DOM
        .then(applyState_notifyChange) // notifie du changement
        .fin(function(/*state*/) {
            isChangingState = false;
        });
}


/* -------------------------
    APPLY STATE : MAKE DIFF
------------------------- */

/**
 * Fait le diff entre les anciennes et nouvelles pages, tant qu'on a des anciennes pages on les conserve, dès qu'il y a une différence, les suivantes sont écrasée.
 *
 * @param  {Array}  state  Liste des pages à afficher.
 *
 * @return  {Promise}  Promesse retournant le "state" après chargement.
 */
function applyState_makeDiff(state) {
    options.debug && console.info('applyState_makeDiff(', state, ')');

    // récupère les pages actuellements affichées
    var oldPages = getCurrentState(true);

    var oldPage = null;
    var oldPageIndex = 0;
    var oldPageFound = false;
    var keepOldPages = true;

    $.each(state, function(i, page) {
        oldPage = oldPages.length > oldPageIndex ? oldPages[oldPageIndex] : null;
        if (keepOldPages && oldPage && oldPage.url === page.url) {
            // remplace dans la liste la page à conserver
            state[i] = oldPage;

            if (page.source) {
                // passe à la page le nouveau contenu chargé au cas ou
                // on en ai besoin. Utilisé lorsque on veut extraire du
                // contenu mise à jour par des requettes différentes sans
                // écraser toute la pages.
                oldPage.$element.trigger(StateManager.REFRESH_SOURCE, [page.source]);
            }

            oldPageIndex++;
            oldPageFound = true;
        }
        else if (oldPageFound) {
            // à partir d'ici les anciennes pages seront écrasées
            keepOldPages = false;
        }
    });

    return Q.resolve(state);
}


/* -------------------------
    APPLY STATE : LOAD PAGES
------------------------- */

/**
 * Charge les pages d'un "state" qui ne le sont pas encore.
 *
 * @param  {Array}  state  Liste des pages à afficher.
 *
 * @return  {Promise}  Promesse retournant le "state" après chargement.
 */
function applyState_loadPages(state) {
    options.debug && console.info('applyState_loadPages(', state, ')');

    var loadingPromises = [];
    $.each(state, function(i, page) {
        // création des $element si on a déjà la source
        if (!page.$element && page.source) {
            page.$element = $(page.source);
        }

        // s'il n'y a pas d'élément ou s'il est vide, on le charge
        if (!page.$element || page.$element.is(':empty')) {
            loadingPromises.push(loadStatePage(page));
        }
    });

    // lorsque tous les éléments sont chargés, on retourne le "state"
    return Q.all(loadingPromises)
    .then(function() {
        return state;
    });
}


/* -------------------------
    APPLY STATE : UPDATE DOM
------------------------- */

/**
 * Affiche les pages du "state" sur le DOM en conservant celle qui
 * le sont déjà.
 *
 * @param  {Array}  state  Liste des pages à afficher.
 *
 * @return  {Promise}
 */
function applyState_updateDom(state) {
    options.debug && console.info('applyState_updateDom(', state, ')');

    var $oldPages = $main.find('> .js-scuba__page');
    var $prevPage = null;
    var $page;

    // place les éléments en faisant attention à ne pas déplacer
    // ceux déjà sur le DOM afin d'éviter le rechargement des
    // iframes et la réinitialisation des transition CSS
    $.each(state, function(i, page) {
        $page = page.$element;

        // pages à conserver retirées de la liste de celles à supprimer
        if ($.inArray($page.get(0), $oldPages) >= 0) {
            $oldPages = $oldPages.not($page);
        }
        // pages à ajouter après la précédente
        else if ($prevPage) {
            $page.insertAfter($prevPage);
        }
        // pages à ajouter au début du #main
        else {
            $page.prependTo($main);
        }

        $prevPage = $page;
    });

    try {
        // initialise les contenus des pages
        $.each(state, function(i, page) {
            initNodeContent(page.$element);
        });
    } catch (error) {
        console.error(error && error.stack ? error.stack : error);
    }

    // supprime les anciennes pages
    try {
        $oldPages.trigger(StateManager.DISPOSE);
    } catch (error) {
        console.error(error);
    }
    $oldPages.remove();

    return Q.resolve(state);
}


/* -------------------------
    APPLY STATE : NOTIFY CHANGE
------------------------- */

/**
 * Notifie le changement d'état.
 *
 * @return {Promise} Promesse retournant l'état appliqué.
 */
function applyState_notifyChange(state) {
    options.debug && console.info('applyState_notifyChange()');

    // modifie le titre de la page
    var lastPage = _.last(state);
    if (lastPage && lastPage.title) {
        document.title = $('<div></div>').html(lastPage.title).text();
    }

    // inverse la liste des pages
    var pages = state.slice(0).reverse();

    // notifie chaque page que les suivantes ont changé
    $.each(pages, function(i, page) {
        page.$element.trigger(StateManager.NEXT_PAGES_CHANGED, [pages.slice(0, i)]);
    });

    // notifie le header que les pages ont changé
    $head.trigger(StateManager.NEXT_PAGES_CHANGED, [pages.slice(0)]);

    // notifie globalement le changement d'état (dans le bon ordre cette fois)
    $window.trigger(StateManager.STATE_CHANGE, [state.slice(0)]);

    return Q.resolve(state);
}


/* -------------------------
    LOAD STATE PAGE
------------------------- */

/**
 * Charge le contenu d'un page et l'ajoute à son objet référent.
 *
 * @param  {Object}  page  Objet de page d'un state.
 *
 * @return  {Promise}  Promesse retournant l'objet page envoyé en paramètre.
 */
function loadStatePage(page) {
    options.debug && console.info('loadStatePage(', page, ')');

    return loadPage(page.url, true)
    .then(function(loadedPages) {

        // pas de page, on déclenche une erreur
        if (loadedPages.length < 1) {
            throw new Error("L'url '"+ page.url +"' ne contient pas d'élement de page correspondant à extraire.");
        }

        // récupère l'élément
        page.$element = loadedPages[0].$element;

        // retourne l'objet page original
        return page;
    });
}


/* -------------------------
    LOAD PAGE
------------------------- */

/**
 * Charge la source d'une url et extrait les différentes pages
 * qu'elle contient. Le résultat de la promesse est un Array de
 * toutes les pages trouvées. Si "single" est spécifié, le
 * résultat ne contiendra que la page correspondante à l'url.
 *
 * @param  {String}  url     Url à charger
 * @param  {Boolean}  single  Demande à ne charger que la div.page correspondant à l'url.
 * @param  {Boolean}  andAfter  Indique si on veut conserver les pages d'après.
 *
 * @return  {Promise}  Promesse retournant la liste des pages chargées.
 */
function loadPage(url, single/*= false*/, andAfter/*= false*/) {
    if (single !== true) single = false;
    if (andAfter !== true) andAfter = false;

    options.debug && console.info('loadPage(', url, single, andAfter, ')');

    var defered = Q.defer();

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'text',
    })
    .done(function(data/*, textStatus, jqXHR*/) {
        var pages = parseStateFromSource(data, single ? url : null, andAfter);
        if (pages.length > 0) defered.resolve(pages);
        else defered.reject("L'url '"+ url +"' ne contient aucun élement de page à extraire.");
    })
    .fail(function(jqXHR/*, textStatus, errorThrown*/) {
        // on cherche quand même des div.page à extraire
        var data = jqXHR.responseText;
        var pages = parseStateFromSource(data);
        if (pages.length > 0) defered.resolve(pages);
        else defered.reject("Erreur durant le chargement de la page '"+ url +'".');
    });

    return defered.promise;
}


/* -------------------------
    PARSE STATE FROM SOURCE
------------------------- */

/**
 * Extrait les pages d'une source HTML. Si un "singlePageUrl" est précisé, le
 * résultat ne contiendra que la page demandée
 *
 * @param  {String}  source         Source HTML.
 * @param  {String}  singlePageUrl  Url de l'unique page à extraire (null par défaut).
 * @param  {Boolean}  andAfter  Indique si on veut conserver les pages d'après.
 *
 * @return  {Array}  Liste des pages extraites.
 */
function parseStateFromSource(source, singlePageUrl/*= null*/, andAfter/*= false*/) {
    if (singlePageUrl === undefined) singlePageUrl = null;
    if (andAfter !== true) andAfter = false;

    options.debug && console.info('parseStateFromSource(', source.length, singlePageUrl, andAfter, ')');

    var state = [];

    var currentUrl = cleaupUrl(window.location.href);

    var titleRgx = /<title>([\w\W]*?)<\/title>/i;
    var title = source.match(titleRgx);
    title = title ? title[1] : '';

    var langRgx = /<!--\[scuba\.langs-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba\.langs\]-->/gi;
    var langLinks = source.match(langRgx);
    if ( langLinks!=undefined && langLinks.length > 0 ) $('#langs').html(langLinks[0]);

    // même expression régulière avec le flag "global" pour la 1re passe et sans pour la 2e
    var rgx1 = /<!--\[scuba\.page-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba\.page\]-->/gi;
    var rgx2 = /<!--\[scuba\.page-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba\.page\]-->/i;

    // 1re passe pour extraire les groupes
    var matches = source.match(rgx1);
    if (matches) {

        var i = 0;
        var n = matches.length;
        var pageMatches, $page, pageUrl;
        // boucle sur tous les groupes trouvés
        for (; i < n; i++) {
            source = matches[i];

            // seconde passe pour extraire le contenu de chaque groupe
            pageMatches = source.match(rgx2);
            if (pageMatches) {
                // créé l'élément DOM jQuery
                $page = $(pageMatches[1]);
                // ajoute le titre de la page chargée
                $page.attr('data-title', title);
                pageUrl = $page.data('url');
                // si précisé, on filtre sur le "singlePageUrl"
                if (!singlePageUrl || singlePageUrl == pageUrl || (andAfter && state.length)) {
                    state.push({
                        url: pageUrl,
                        title: title,
                        source: pageMatches[1],
                        isCurrent: isCurrentPage(pageUrl, currentUrl),
                        $element: $page,
                    });
                }
            }
        }

    }

    return state;
}


/* -------------------------
    GET CURRENT STATE
------------------------- */

/**
 * Récupère l'état actuel de la page.
 *
 * @param  {Bool}  withElements  Indique si les objets retournées doivent posséder une référence des éléments du DOM (false par défaut).
 * @param  {Bool}  stopAtPageUrl  Indique à quelle url de page arréter la récupération de l'état actuel.
 *
 * @return  {Array}  Liste des pages actuellement affichées.
 */
StateManager.getCurrentState = getCurrentState;
function getCurrentState(withElements/*= false*/, stopAtPageUrl/*= null*/) {
    if (withElements !== true) withElements = false;

    options.debug && console.info('getCurrentState(', withElements, ')');

    var state = [];

    var currentUrl = cleaupUrl(window.location.href);

    var $page, page;
    $main.find('> .js-scuba__page').each(function(i, pageElm) {
        $page = $(pageElm);

        // création de l'objet et récupération des infos
        page = {
            url: $page.data('url'),
        };

        // indique si c'est la page en cours
        page.isCurrent = isCurrentPage(page.url, currentUrl);

        // si précisé, ajout de l'élément du DOM
        if (withElements) {
            page.$element = $page;
            page.title = $page.data('title');
        }

        state.push(page);

        if (stopAtPageUrl && stopAtPageUrl === page.url) {
            return false; // équivalent de break
        }
    });

    return state;
}


/* -------------------------
    INIT NODE CONTENT
------------------------- */

/**
 * Déclenche l'évènement indiquant qu'un élément est prêt
 * à être initialisé.
 *
 * @param  {jQuery Elements}  $node  Élément jQuery du DOM à initialiser.
 */
function initNodeContent($node) {
    // sécurité au cas ou l'objet jQuery contiendrait plusieurs éléments.
    if ($node.length > 1) {
        $node.each(function(i, node) {
            initNodeContent($(node));
        });
        return;
    }

    if ($node.data('__scuba_contentInitialized') !== true) {
        // déclenche l'évènement
        $window.trigger(StateManager.CONTENT_READY, [$node.get(0)]);
        // évite une seconde initialisation
        $node.data('__scuba_contentInitialized', true);
    }
}


/* --------------------------------------------------

    MODULE EXPORT

-------------------------------------------------- */

export default StateManager;


// WEBPACK FOOTER //
// ./scripts/scuba/StateManager.js